import React from 'react'
import { Route } from 'react-router-dom'

import MilitaryProfile from './MilitaryProfile'
import MilitarySearch from './MilitarySearch'
import MilitarySearchResults from './MilitarySearchResults'

function MilitaryRoutes(props) {
  return (
    <>
      <Route path="/military/profile/:mocId" component={MilitaryProfile} />
      <Route path="/occupations/military" component={MilitarySearch} />
      <Route path="/search/military" component={MilitarySearchResults} exact />
    </>
  )
}

MilitaryRoutes.propTypes = {}
MilitaryRoutes.defaultProps = {}

export default MilitaryRoutes
